import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getMarketplaceEuBackend } from '../../config/appConfig';
import { accessToken } from '../../../../configuration/tokenHandling/accessToken';

export type PaymentMethodType = 'BANK_TRANSFER';

export interface PaymentMethodSetup {
    payment_type: PaymentMethodType;
}

export interface PaymentMethod {
    id: string;
    payment_type: PaymentMethodType;
}

export const paymentApiSlice = createApi({
    reducerPath: 'paymentApi',
    baseQuery: fetchBaseQuery({
        baseUrl: getMarketplaceEuBackend(),
        prepareHeaders: headers => {
            const token = accessToken.getAccessToken();
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: builder => ({
        setupPaymentMethod: builder.mutation<PaymentMethod, { accountId: string; body: PaymentMethodSetup }>({
            query: ({ accountId, body }) => ({
                url: `/admin/accounts/${accountId}/payment-methods`,
                method: 'POST',
                body: { payment_type: body.payment_type },
            }),
        }),
    }),
});

export const { useSetupPaymentMethodMutation } = paymentApiSlice;
